/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find the original value before a percentage increase?`)
};

const es_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo encuentro el valor original antes de un aumento porcentual?`)
};

const de_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich den ursprünglichen Wert vor einem prozentualen Anstieg?`)
};

const nl_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vind ik de oorspronkelijke waarde vóór een percentagestijging?`)
};

const fr_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver la valeur d’origine avant une augmentation en pourcentage ?`)
};

const it_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo il valore originale prima di un aumento percentuale?`)
};

const pt_br2_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o valor original antes de um aumento percentual?`)
};

const pt_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o valor original antes de um aumento percentual?`)
};

const ja_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント増加が起こる前の元の値を求めるには？`)
};

const zh_pct_increase_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何求出百分比增长之前的原始值？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_increase_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_increase_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_increase_faq4_q", locale)
	if (locale === "en") return en_pct_increase_faq4_q(inputs)
	if (locale === "es") return es_pct_increase_faq4_q(inputs)
	if (locale === "de") return de_pct_increase_faq4_q(inputs)
	if (locale === "nl") return nl_pct_increase_faq4_q(inputs)
	if (locale === "fr") return fr_pct_increase_faq4_q(inputs)
	if (locale === "it") return it_pct_increase_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_increase_faq4_q(inputs)
	if (locale === "pt") return pt_pct_increase_faq4_q(inputs)
	if (locale === "ja") return ja_pct_increase_faq4_q(inputs)
	return zh_pct_increase_faq4_q(inputs)
};